import { track } from "jiffy-analytics";
import "./digital-assets-form-search.scss";
import EventClass from "common/utils/ui/event-class";

export class DigitalAssetsFormSearch extends EventClass {
  #formSelector;

  constructor(options = { formSelector: "" }) {
    super({
      eventSelector: options.formSelector,
      event: "submit"
    });

    this.#formSelector = options.formSelector;
  }

  get $form() {
    return document.querySelector(this.#formSelector);
  }

  get $queryInput() {
    return this.$form.querySelector('input[name="q"]');
  }

  event() {
    track("digital_asset_searched", { query: this.$queryInput?.value });
  }
}

export default () =>
  new DigitalAssetsFormSearch({
    formSelector: ".js-digital-assets-form-search"
  });
